import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { ReactionResultDTO } from '@nora-monorepo/nora-api-client';
import { useApiStore } from '@nora-monorepo/ui-shared';

export const useReactionsModalStore = defineStore('reactionsModalStore', () => {
  const isOpen = ref(false);
  const messageId = ref<string>();
  const conversationId = ref<string>();
  const isLoading = ref(false);
  const reactions = ref<ReactionResultDTO[]>([]);
  const api = useApiStore();
  let requestVersion = 0;

  async function openModal(newMessageId: string, newConversationId: string): Promise<void> {
    messageId.value = newMessageId;
    conversationId.value = newConversationId;
    isOpen.value = true;

    await fetchReactionsData(newMessageId, newConversationId);
  }

  async function fetchReactionsData(messageId: string, conversationId: string): Promise<void> {
    const currentRequestVersion = ++requestVersion;
    reactions.value = [];
    isLoading.value = true;

    try {
      const result = await api.unwrap(
        api.conversationMessage.getMessageReactions({
          messageId,
          conversationId,
        }),
      );

      if (currentRequestVersion !== requestVersion) {
        return;
      }
      reactions.value = result.data ?? [];
    }
    finally {
      if (currentRequestVersion === requestVersion) {
        isLoading.value = false;
      }
    }
  }

  function reset(): void {
    requestVersion++;
    isOpen.value = false;
    messageId.value = undefined;
    conversationId.value = undefined;
    isLoading.value = false;
    reactions.value = [];
  }

  return {
    isOpen,
    messageId,
    conversationId,
    isLoading,
    reactions,

    openModal,
    fetchReactionsData,
    reset,
  };
});
